import React, { FC } from 'react';
import styles from './PaymentPayable.module.scss';

interface PaymentPayableProps {}

const PaymentPayable: FC<PaymentPayableProps> = () => (
  <div className={styles.PaymentPayable}>
    PaymentPayable Component
  </div>
);

export default PaymentPayable;
